var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"size":_vm.sizeInPixel,"color":_vm.color,"left":_vm.left,"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }